export default __webpack_public_path__ + "static/media/vcr_osd_mono_webfont.7c393e1a.ttf";